<template>
	<div class="el-card" :class="shadow ? 'is-' + shadow + '-shadow' : 'is-always-shadow'">
		<div class="el-card__header" v-if="$slots.header || header">
			<div class="el-card__tools" v-if="$slots.tools">
				<slot name="tools"></slot>
			</div>
			<slot name="header">{{ header }}</slot>
		</div>
		<el-scrollbar v-if="scrollable" class="el-card__body" :style="bodyStyle">
			<slot></slot>
		</el-scrollbar>
		<div v-else class="el-card__body" :style="bodyStyle">
			<slot></slot>
		</div>
		<div class="el-card__footer" v-if="$slots.footer">
			<slot name="footer"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ElCard',
	props: {
		header: {},
		bodyStyle: {},
		scrollable: {
			type: Boolean,
			default: true,
		},
		shadow: {
			type: String,
		},
	},
};
</script>
<style>
.el-card {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
}
.el-card__header {
	line-height: 32px;
	height: auto;
}
.el-card__tools {
	float: right;
}
.el-card__body {
	flex: 1;
	display: flex;
}
.el-card__footer {
	background-color: #f5f7fa;
	color: #333;
	text-align: left;
	padding: 5px;
	border-top: 1px solid #cdcdcd;
}
.el-card__body > .el-scrollbar__wrap {
	margin: 0 !important;
	flex: 1;
}
.el-card__body > .el-scrollbar__wrap::-webkit-scrollbar {
	display: none;
}
.el-scrollbar__bar.is-horizontal {
	display: none;
}
</style>
